export default __webpack_public_path__ + "static/media/Banner_Mobile.22b74d89.png";